// extracted by mini-css-extract-plugin
export default {"wrap":"NE-z","fullWidth":"OE-z","hideOnDesktop":"PE-z","content":"QE-z","hasOpenedNav":"RE-z","crumbsList":"SE-z","dropdownsWrap":"TE-z"};